import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class McatalogConfigDaoService {

  private BASE_URL = environment.apiURL;
  private OPTIONS = {
    headers: new HttpHeaders({
      'Content-Type': 'application/json; charset=UTF-8'
    })
  };

  constructor(private http: HttpClient) { }

  public getMCatalogGateways(context, lang, udid) {
    const options = {};
    Object.assign(options, this.OPTIONS);
    options['headers'] = options['headers'].append('context', context);
    options['headers'] = options['headers'].append('lang', lang);
    options['headers'] = options['headers'].append('udid', udid);
    return this.http.get(this.BASE_URL + 'private/v2.0/payment/mcatalog', options);
  }

  public getMCatalogConfig(context, lang, udid) {
    const options = {};
    Object.assign(options, this.OPTIONS);
    options['headers'] = options['headers'].append('context', context);
    options['headers'] = options['headers'].append('lang', lang);
    options['headers'] = options['headers'].append('udid', udid);
    return this.http.get(this.BASE_URL + 'private/v2.0/mcatalog/config', options);
  }

  public getMCatalogServices(context, lang, udid) {
    const options = {};
    Object.assign(options, this.OPTIONS);
    options['headers'] = options['headers'].append('context', context);
    options['headers'] = options['headers'].append('lang', lang);
    options['headers'] = options['headers'].append('udid', udid);
    return this.http.get(this.BASE_URL + 'private/v2.0/mcatalog/config/services', options);
  }

  public updateMCatalogGateways(context, lang, udid, internalIds) {
    const options = {};
    Object.assign(options, this.OPTIONS);
    options['headers'] = options['headers'].append('context', context);
    options['headers'] = options['headers'].append('lang', lang);
    options['headers'] = options['headers'].append('udid', udid);
    const item = { internalIds };
    return this.http.patch(this.BASE_URL + 'private/v2.0/payment/mcatalog', item, options);
  }

  public updateMCatalogServices(context, lang, udid, services) {
    const options = {};
    Object.assign(options, this.OPTIONS);
    options['headers'] = options['headers'].append('context', context);
    options['headers'] = options['headers'].append('lang', lang);
    options['headers'] = options['headers'].append('udid', udid);
    const item = { services };
    return this.http.post(this.BASE_URL + 'private/v2.0/mcatalog/config/services', item, options);
  }

  public updateMCatalogBanner(context, lang, udid, banner) {
    const options = {};
    Object.assign(options, this.OPTIONS);
    options['headers'] = options['headers'].append('context', context);
    options['headers'] = options['headers'].append('lang', lang);
    options['headers'] = options['headers'].append('udid', udid);
    const item = { banner };
    return this.http.patch(this.BASE_URL + 'private/v2.0/mcatalog/config', item, options);
  }

  public updateMCatalogTickets(context, lang, udid, ticketCustomerInternalId, ticketStaffInternalId) {
    const options = {};
    Object.assign(options, this.OPTIONS);
    options['headers'] = options['headers'].append('context', context);
    options['headers'] = options['headers'].append('lang', lang);
    options['headers'] = options['headers'].append('udid', udid);
    const item = { ticketCustomerInternalId, ticketStaffInternalId };
    return this.http.patch(this.BASE_URL + 'private/v2.0/mcatalog/config', item, options);
  }

  public updateMCatalogColor(context, lang, udid, primaryColor, secondaryColor) {
    const options = {};
    Object.assign(options, this.OPTIONS);
    options['headers'] = options['headers'].append('context', context);
    options['headers'] = options['headers'].append('lang', lang);
    options['headers'] = options['headers'].append('udid', udid);
    const item = { primaryColor, secondaryColor };
    return this.http.patch(this.BASE_URL + 'private/v2.0/mcatalog/config', item, options);
  }

  public updateMCatalogInactivityTime(context, lang, udid, inactivityTime) {
    const options = {};
    Object.assign(options, this.OPTIONS);
    options['headers'] = options['headers'].append('context', context);
    options['headers'] = options['headers'].append('lang', lang);
    options['headers'] = options['headers'].append('udid', udid);
    const item = { inactivityTime };
    return this.http.patch(this.BASE_URL + 'private/v2.0/mcatalog/config', item, options);
  }

  public updateCatalogsConfigHelp(context, lang, udid, assistanceActive) {
    const options = {};
    Object.assign(options, this.OPTIONS);
    options['headers'] = options['headers'].append('context', context);
    options['headers'] = options['headers'].append('lang', lang);
    options['headers'] = options['headers'].append('udid', udid);
    const item = { assistanceActive };
    return this.http.patch(this.BASE_URL + 'private/v2.0/mcatalog/config', item, options);
  }
}
